import type * as React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { ErrorBoundary } from './ErrorBoundary'

/**
 * Wrapper to inject router props into class component
 */
const ErrorBoundaryWithRouter = (props: { children?: React.ReactNode }) => {
  const location = useLocation()
  const navigate = useNavigate()

  return <ErrorBoundary {...props} location={location} navigate={navigate} />
}

export default ErrorBoundaryWithRouter
